/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Missing_PublicationInputs */

const cs_enum_missing_publication = /** @type {(inputs: Enum_Missing_PublicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybí na portálu`)
};

const en_enum_missing_publication = /** @type {(inputs: Enum_Missing_PublicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing on portal`)
};

/**
* | output |
* | --- |
* | "Missing on portal" |
*
* @param {Enum_Missing_PublicationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_missing_publication = /** @type {((inputs?: Enum_Missing_PublicationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Missing_PublicationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_missing_publication(inputs)
	return cs_enum_missing_publication(inputs)
});